// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import type { MedplumClient } from '@medplum/core';
import type { HealthcareService, Practitioner, PractitionerRole, Schedule } from '@medplum/fhirtypes';
import type { AvailabilitySearchRepository } from '@polarissleep/scheduling-next';

type SearchableResource = HealthcareService | PractitionerRole | Practitioner | Schedule;

/** Creates the tenant-filtered resource repository used by the shared v2 search. */
export function createPatientAvailabilityRepository(medplum: MedplumClient): AvailabilitySearchRepository {
  return {
    searchResourcePages(resourceType, search) {
      return searchResourcePages(medplum, resourceType, search);
    },
  } as AvailabilitySearchRepository;
}

function searchResourcePages(
  medplum: MedplumClient,
  resourceType: AvailabilitySearchRepositoryResourceType,
  search: Record<string, string>
): AsyncIterable<SearchableResource[]> {
  return medplum.searchResourcePages(resourceType, search) as unknown as AsyncIterable<SearchableResource[]>;
}

type AvailabilitySearchRepositoryResourceType = 'HealthcareService' | 'PractitionerRole' | 'Practitioner' | 'Schedule';
